import { redirect } from 'react-router'
import { publicAction } from '@/data/loaders';

export function loadFiles({ request, params }, view) {
  const { folder_id } = params;
  return new Promise(function(resolve, reject) {
    if (folder_id || ["scenarios", "rubrics"].includes(view)) {
      publicAction("getFiles", { parent: folder_id || null, view: (folder_id ? null : view) }, { educatorOnly: redirect("/courses") }).then(function({ data }) {
        if (data.folder || !folder_id) {
          resolve({ data });
        } else {
          reject({text: "Folder not found or you don't have permission to access it", path: "/scenarios", status: 404 });
        }
      }).catch(reject);
    } else if (view === "shared") {
      publicAction("getSharedFiles", {}, { educatorOnly: redirect("/courses") }).then(function({ data }) {
        resolve({ data });
      }).catch(reject);
    } else if (view === "trash") {
      publicAction("getTrashedFiles", {}, { educatorOnly: redirect("/courses") }).then(function({ data }) {
        resolve({ data });
      }).catch(reject);
    }
  });
}